import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

export enum EMapType {
  satellite = 'satellite',
  vector_color = 'vector_color',
  vector_white = 'vector_white',
}

type MapSettingProps = {
  showVesselOnline: boolean;
  showVesselOffline: boolean;
  showVesselWaiting: boolean;
  showVesselLabel: boolean;
  showVesselTrail: boolean;
  showDotTrail: boolean;
  trailWidth: any;
  trailOpacity: any;
  trailLength: any;
  mapType: EMapType;
  activeLayer: string;
  showWindLayer: boolean;
  loadingWindDirection: boolean;
  showWaveLayer: boolean;
  loadingWaveDirection: boolean;
  showTimezoneLayer: boolean;
  forecastDate: string | null;
  dataSource: 'GSM' | 'SATELLITE';
  setDataSource: (val: 'GSM' | 'SATELLITE') => void;
  setShowVesselOnline: (val: boolean) => void;
  setShowVesselOffline: (val: boolean) => void;
  setShowVesselWaiting: (val: boolean) => void;
  setShowVesselLabel: (val: boolean) => void;
  setShowVesselTrail: (val: boolean) => void;
  setShowDotTrail: (val: boolean) => void;
  setTrailWidth: (val: any) => void;
  setTrailOpacity: (val: any) => void;
  setTrailLength: (val: any) => void;
  setMapType: (val: EMapType) => void;
  setActiveLayer: (val: string) => void;
  setShowWindLayer: (val: boolean) => void;
  setShowWaveLayer: (val: boolean) => void;
  setShowTimezoneLayer: (val: boolean) => void;
  setLoadingWindDirection: (val: boolean) => void;
  setLoadingWaveDirection: (val: boolean) => void;
  setForecastDate: (val: string | null) => void;
};

type MyPersist = (
  config: any,
  options: PersistOptions<MapSettingProps>
) => StateCreator<MapSettingProps>;

const useMapSetting = create<MapSettingProps>(
  (persist as MyPersist)(
    (set: any) => ({
      showVesselOnline: true,
      showVesselOffline: true,
      showVesselWaiting: true,
      showVesselLabel: true,
      showVesselTrail: false,
      showDotTrail: false,
      trailWidth: 5,
      trailOpacity: 1,
      trailLength: 24,
      mapType: EMapType.satellite,
      showTimezoneLayer: false,
      showWindOverlay: false,
      loadingWindDirection: false,
      showWaveLayer: false,
      loadingWaveDirection: false,
      activeLayer: '',
      forecastDate: null,
      dataSource: 'GSM' as 'GSM' | 'SATELLITE',
      setDataSource: (val: 'GSM' | 'SATELLITE') => {
        set({ dataSource: val });
      },
      setActiveLayer: (val: string) => {
        set({ activeLayer: val });
      },
      setLoadingWindDirection: (val: boolean) => {
        set({ loadingWindDirection: val });
      },
      setLoadingWaveDirection: (val: boolean) => {
        set({ loadingWaveDirection: val });
      },
      setShowWindLayer: (val: boolean) => {
        set({ showWindLayer: val });
      },
      setShowWaveLayer: (val: boolean) => {
        set({ showWaveLayer: val });
      },
      setShowTimezoneLayer: (val: boolean) => {
        set({ showTimezoneLayer: val });
      },
      setForecastDate: (val: string | null) => {
        set({ forecastDate: val });
      },
      setShowVesselOnline: (val: boolean) => {
        set({ showVesselOnline: val });
      },
      setShowVesselOffline: (val: boolean) => {
        set({ showVesselOffline: val });
      },
      setShowVesselWaiting: (val: boolean) => {
        set({ showVesselWaiting: val });
      },
      setShowVesselLabel: (val: boolean) => {
        set({ showVesselLabel: val });
      },
      setShowVesselTrail: (val: boolean) => {
        set({ showVesselTrail: val });
      },
      setShowDotTrail: (val: boolean) => {
        set({ showDotTrail: val });
      },
      setTrailWidth: (val: any) => {
        set({ trailWidth: val });
      },
      setTrailOpacity: (val: any) => {
        set({ trailOpacity: val });
      },
      setTrailLength: (val: any) => {
        set({ trailLength: val });
      },
      setMapType: (val: EMapType) => {
        set({ mapType: val });
      },
    }),
    {
      name: 'map-settings',
      getStorage: () => localStorage,
    }
  )
);

export default useMapSetting;
